// extracted by mini-css-extract-plugin
export default {"SpreadListView":"SpreadListView_SpreadListView__8uEXE"};